import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(private router: Router, private zone: NgZone) {
    this.initDeepLinks();
  }

  private initDeepLinks() {
    if (!Capacitor.isNativePlatform()) return;

    App.addListener('appUrlOpen', (event) => {
      this.zone.run(() => {
        try {
          const url = new URL(event.url);
          const path = url.pathname || url.host;
          const search = url.search;
          this.router.navigateByUrl('/' + path + search);
        } catch {
          // ignore malformed URLs
        }
      });
    });
  }
}
